var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2394_4093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0943304 17.7734C0.192697 17.915 0.354381 18 0.527419 18H17.4726C17.6456 18 17.8073 17.915 17.9056 17.7734C18.0045 17.6312 18.0272 17.45 17.9664 17.2878C17.7609 16.7383 17.3768 16.2562 17.2207 16.075C17.1208 15.9581 16.9746 15.8906 16.8206 15.8906H1.17939C1.02541 15.8906 0.879157 15.9581 0.779243 16.075C0.62322 16.2562 0.239033 16.7383 0.0335454 17.2878C-0.0272045 17.45 -0.0045639 17.6312 0.0943304 17.7734Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10938 8.47266H5.30859V14.8359H2.10938V8.47266Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41797 8.47266H10.582V14.8359H7.41797V8.47266Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6914 8.47266H15.8906V14.8359H12.6914V8.47266Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14142 7.26268C1.24042 7.36207 1.37819 7.41796 1.51446 7.41796C1.51453 7.41796 1.51463 7.41789 1.5147 7.41789C1.51477 7.41789 1.51488 7.41796 1.51495 7.41761H16.485C16.4851 7.41796 16.4852 7.41789 16.4853 7.41789C16.4853 7.41789 16.4854 7.41796 16.4855 7.41796C16.6218 7.41796 16.7595 7.3621 16.8585 7.26268C16.9658 7.15538 17.7678 6.32025 17.9999 5.30859H0C0.232207 6.32025 1.03408 7.15538 1.14142 7.26268Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6644 4.2539L9.23586 0.0556084C9.08754 -0.0185361 8.91246 -0.0185361 8.76413 0.0556084L0.335632 4.2539H17.6644Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2394_4093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.48341b57d0d9250af9a53a067c86946d.svg";
export { ForwardRef as ReactComponent };